import { render, staticRenderFns } from "./StateAgents.vue?vue&type=template&id=2b8bb054"
import script from "./StateAgents.vue?vue&type=script&lang=js"
export * from "./StateAgents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports